export enum RecipeMenuOptions {
    DELETE_RECIPE = "DELETE",
    RENAME_RECIPE = "RENAME",
    SHARE_RECIPE = "SHARE",
    COPY_INGREDIENTS = "COPY_INGREDIENTS"
}

export const RECIPE_NAME_REGEX = /^(?=.*[A-Za-z0-9])[\s\S]+$/;
